import React, { Suspense, useEffect } from "react";
import ReactGA from "react-ga";
import { Switch, withRouter, Redirect, useHistory } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FullPageLoader from "../components/Common/FullPageLoader";
import RootComponent from "sushiweb/RootComponent";
import ToastContainer from "sushiweb/ToastContainer";

import MainNavBar from "../components/MainNavBar/MainNavBar";
import Home from "../views/Home";
import PrivateRoute from "./PrivateRoute";
import { privateRoutes as routes } from "./routes";
import * as MenuActionsActions from "../store/actions/MenuActions";
import Toast from "../components/Common/Toast";
import ErrorMsgs from "../constants/Errors.json";
import { DashboardMainContainer } from "../constants/assets/containers";

function AppRouter(props) {
  const history = useHistory();
  const location = history.location;
  const routeComponents = routes
    .filter((routeObj) => props.menus.has(routeObj.menuName))
    .map(({ path, component, exact }, key) => {
      return (
        <PrivateRoute
          path={path}
          component={component}
          exact={exact}
          key={key}
        />
      );
    });

  const handleReset = () => {
    console.log("redirecting...");
    history.push("/");
    //to rerender the page
    history.go(0);
  };

  function ErrorFallback({ error, resetStatusBoundary }) {
    return (
      <div role="alert" className="p-30">
        <p>Something went wrong:</p>
        <pre>{error.message}</pre>
        <button onClick={() => handleReset()}>Try again</button>
      </div>
    );
  }

  useEffect(() => {
    if (props.menus.size === 0) {
      props.getMenusList();
    }
    const len = history.location.pathname.length;
    if (
      history.location.pathname[len - 1] === "/" &&
      history.location.pathname !== "/" &&
      history.location.search === ""
    ) {
      history.push(history.location.pathname.substr(0, len - 1));
    }
  }, []);

  // const DisclaimerText = () => {
  //   return(
  //     <div className="disclaimer-text-container">
  //       <p className="disclaimer-text text-center">
  //     You are attempting to access the property of the Zomato, this service is exclusively for authorized users and owners.
  //     You agree to maintain the confidentiality, integrity, and accessibility of the data.
  //       </p>
  //     </div>
  //   );
  // };

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [window.location.pathname]);

  const handleErrors = (error, info) => {
    console.log(error);
  };

  if (props.menus.size === 0 && props.failedToFetchMenu === false) {
    return <FullPageLoader size={100} />;
  }

  if (props.failedToFetchMenu === true) {
    return <Toast type="error" message={ErrorMsgs.UNABLE_TO_LOAD} />;
  }

  const shouldRemovePadding = () => {
    const isSameRoute = (route, path) => {
      const routeParts = route?.split("/");
      const pathParts = path?.split("/");
      if (routeParts.length !== pathParts.length) {
        return false;
      }
      return routeParts.every((part, index) => {
        return part === pathParts[index] || part.startsWith(":");
      });
    };

    let shouldRemovePadding = false;
    routes
      .filter((routeObj) => props.menus.has(routeObj.menuName))
      .map(({ path, removePadding }) => {
        if (isSameRoute(path, location.pathname)) {
          shouldRemovePadding = removePadding ?? false;
        }
      });
    return shouldRemovePadding;
  };

  return (
    <Suspense fallback={<FullPageLoader size={100} />}>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={handleErrors}
        onReset={handleReset}
      >
        <DashboardMainContainer>
          <RootComponent>
            <ToastContainer>
              <MainNavBar removePadding={shouldRemovePadding()}>
                <Switch>
                  <PrivateRoute exact={true} path={"/"} component={Home} />
                  {routeComponents}
                  <Redirect exact={true} to="/" />
                </Switch>
              </MainNavBar>
            </ToastContainer>
          </RootComponent>
        </DashboardMainContainer>
        {/* {
          history.location.pathname==="/" &&
          <DisclaimerText />
        } */}
      </ErrorBoundary>
    </Suspense>
  );
}

const mapStateToProps = (state) => {
  const { MenuActions } = state;
  return {
    menus: MenuActions.menus,
    failedToFetchMenu: MenuActions.failedToFetchMenu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getMenusList: bindActionCreators(MenuActionsActions.getMenusList, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AppRouter)
);
